import React, { memo, useEffect, useMemo, useState } from "react";
import { FlatList, StyleSheet, TouchableOpacity, useWindowDimensions, View, Text, ScrollView } from "react-native"
import CustomPressable from "../../components/customPressable/customPressable";
import { ImageComp } from "../../components/Image/Image";
import { ADD, CHEVRON_RIGHT, MINUS, PLUS } from "../../assets";
import { useTranslation } from "react-i18next";
import { useCssStyle } from "../../customHook/getCssStyle";
import { useDispatch, useSelector } from "react-redux";
import { getCleanUrl } from "../../utils/Helper";
import { COLORS } from "../../style";
import CustomFlatList from "../../components/customFlatList";
import { HCOMMERCE } from "../../config/Constant";
import { sendAnalytics } from "../../Redux/Actions/analyticsAction";
import RenderHTML from "react-native-render-html";

export const StoreLevel1 = memo((props) => {

    const { storeData, handleStoreItemSubTypeSelect, cartItem, handleAddToCart, handleRemoveFromCart, handleItemInfo } = props || {};

    const { t } = useTranslation();
    const getStyles = useCssStyle();
    const dispatch = useDispatch();
      const { width } = useWindowDimensions()
    

    const { currentWidget } = useSelector(state => state.deviceConfigSlice);
    
    const { currencyDetails } = useSelector(state => state.deviceConfigSlice);
    const currencyCode = currencyDetails.code;

    const [selectedStoreType, setSelectedStoreType] = useState({});

    const handleSelectStoreType = (selectedStoreType) => {

        setSelectedStoreType(selectedStoreType);

    };

    useEffect(()=>{
        dispatch(sendAnalytics(HCOMMERCE, "STORE LEVEL - 1", { storeName: props.storeName, element: "widget", storeSku: currentWidget.storeSku, widgetSessionId: props.hcommerceSessionToken }))

        // eslint-disable-next-line react-hooks/exhaustive-deps
    },[])


    // console.log("currentWidget", currentWidget, getCleanUrl(currentWidget?.widgetHeaderImageUrl));

    const customWidgetTitleStyle = useMemo(() => {
        const style = getStyles(['list_itemContainer_textContainer_title', 'hcommerce_storelevel1_itemContainer_textContainer_title']);
        return Array.isArray(style) ? Object.assign({}, ...style) : style || {};

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const customWidgetSubTitleStyle = useMemo(() => {
        const style = getStyles(['list_itemContainer_textContainer_subtitle', 'hcommerce_storelevel1_itemContainer_textContainer_subtitle']);
        return Array.isArray(style) ? Object.assign({}, ...style) : style || {};

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);




    return (
        <View style={getStyles(['widgetmainContainer', 'hcommerce_storelevel1_MainContainer'])} id="widgetmainContainer hcommerce_storelevel1_MainContainer">

            {
                currentWidget?.widgetHeaderImageUrl &&
                <ImageComp source={getCleanUrl(currentWidget?.widgetHeaderImageUrl)} style={getStyles(['widgetmainContainerHeaderImg', 'hcommerce_storelevel1_HeaderImg'])} id={`widgetmainContainerHeaderImg hcommerce_storelevel1_HeaderImg`} />
            }
            <View style={getStyles(['widgetmainContainerHeaderContainer', 'hcommerce_storelevel1_HeaderContainer'])} id="widgetmainContainerHeaderContainer hcommerce_storelevel1_HeaderContainer">
                <View style={getStyles(['widgetmainContainerHeaderTitleContainer', 'hcommerce_storelevel1_HeaderTitleContainer'])} id="widgetmainContainerHeaderTitleContainer hcommerce_storelevel1_HeaderTitleContainer">
                    <Text style={getStyles(['widgetmainContainerHeaderTitle', 'hcommerce_storelevel1_HeaderTitle'])} id={`widgetmainContainerHeaderTitle hcommerce_storelevel1_HeaderTitle`}>{currentWidget.displayName}</Text>
                </View>
                <View style={getStyles(["hcommerce_storelevel1_MainContainerChildContainerPillContainer"])} id="hcommerce_storelevel1_MainContainerChildContainerPillContainer">

                    {storeData?.storeItemTypeInfo?.length > 0 &&
                        <ScrollView horizontal showsHorizontalScrollIndicator={false} contentContainerStyle={getStyles(['hcommerce_storelevel1_PillContainer'])} id="hcommerce_storelevel1_PillContainer" style={{ width: '100%' }}>
                            <CustomPressable onPress={() => handleSelectStoreType({})} style={getStyles(['hcommerce_storelevel1_Pill', !selectedStoreType.id && 'hcommerce_storelevel1_SelectedPill'])} id={`hcommerce_storelevel1_Pill hcommerce_storelevel1_SelectedPill`}>
                                <Text style={getStyles(['hcommerce_storelevel1_Pill_Text', !selectedStoreType.id && 'hcommerce_storelevel1_SelectedPill_Text'])} id={`hcommerce_storelevel1_Pill_Text hcommerce_storelevel1_SelectedPill_Text`}>{t('h-commerce.all')}</Text>
                            </CustomPressable>

                            {storeData?.storeItemTypeInfo.map((iterator) => (
                                <CustomPressable key={iterator.id} onPress={() => handleSelectStoreType(iterator)} style={getStyles(['hcommerce_storelevel1_Pill', selectedStoreType.id == iterator.id && 'hcommerce_storelevel1_SelectedPill'])} id={`hcommerce_storelevel1_Pill hcommerce_storelevel1_SelectedPill`}>
                                    <Text style={getStyles(['hcommerce_storelevel1_Pill_Text', selectedStoreType.id == iterator.id && 'hcommerce_storelevel1_SelectedPill_Text'])} id={`hcommerce_storelevel1_Pill_Text hcommerce_storelevel1_SelectedPill_Text_${iterator.id}`}>{iterator.typeName}</Text>
                                </CustomPressable>
                            ))}
                        </ScrollView>
                    }

                </View>
            </View>


            <ScrollView showsVerticalScrollIndicator={false} contentContainerStyle={getStyles(['widgetmainContainerChildContainer', 'hcommerce_storelevel1_MainContainerChildContainer'])} id="widgetmainContainerChildContainer hcommerce_storelevel1_MainContainerChildContainer">

                {storeData?.storeItemTypeInfo?.map((storeItemTypeInfo) => {

                    const renderAll = !selectedStoreType.id;


                    if (renderAll || (selectedStoreType.id === storeItemTypeInfo.id)) {
                        return (

                            <View style={getStyles(['hcommerce_storelevel1_ChildContainer'])}   id={`hcommerce_storelevel1_ChildContainer hcommerce_storelevel1_ChildContainer_${storeItemTypeInfo.id}`} key={storeItemTypeInfo.id}>
                                <Text style={getStyles(['hcommerce_storelevel1_ChildContainer_Title'])} id={`hcommerce_storelevel1_ChildContainer_Title hcommerce_storelevel1_ChildContainer_Title_${storeItemTypeInfo.id}`} >{storeItemTypeInfo.typeName}</Text>

                                {storeData.storeItemSubTypeInfo?.length > 0 && <View style={getStyles(['hcommerce_storelevel1_ChildContainer_items_container'])} id={`hcommerce_storelevel1_ChildContainer_items_container hcommerce_storelevel1_ChildContainer_items_container_${storeItemTypeInfo.id}`}>
                                    {storeData.storeItemSubTypeInfo.map((storeItemSubTypeInfo) => {
                                        const imageUri = storeItemSubTypeInfo.storeItemTypeImages?.find(image => image.imageType === "LARGE")?.imagePath || storeItemSubTypeInfo.storeItemTypeImages?.[0]?.imagePath;
                                        if (storeItemTypeInfo.storeItemSubTypeID.includes(storeItemSubTypeInfo.id)) {
                                            return (
                                                <CustomPressable style={getStyles(['list_itemContainer', 'hcommerce_storelevel1_itemContainer'])} id={`list_itemContainer hcommerce_storelevel1_itemContainer_${storeItemSubTypeInfo.id}`} onPress={() => handleStoreItemSubTypeSelect(storeItemSubTypeInfo)}>

                                                    <View style={getStyles(['list_itemContainer_image', 'hcommerce_storelevel1_itemContainer_image'])} id="list_itemContainer_image hcommerce_storelevel1_itemContainer_image">
                                                        {imageUri &&
                                                            <ImageComp
                                                                source={getCleanUrl(imageUri)}
                                                                style={getStyles(["hcommerce_storelevel1_item_image", { width: "100%", height: "100%" }])}
                                                                id="hcommerce_storelevel1_item_image"

                                                            />
                                                        }
                                                    </View>
                                                    <View style={getStyles(['list_itemContainer_textContainer', 'hcommerce_storelevel1_itemContainer_textContainer'])} id="list_itemContainer_textContainer hcommerce_storelevel1_itemContainer_textContainer">

                                                        <RenderHTML
                                                            contentWidth={width}
                                                            baseStyle={customWidgetTitleStyle}
                                                            source={{ html: storeItemSubTypeInfo.subTypeName}}
                                                            systemFonts={[customWidgetTitleStyle.fontFamily]}
                                                            id={`list_itemContainer_textContainer_title hcommerce_storelevel1_itemContainer_textContainer_title_${storeItemSubTypeInfo.id}`}
                                                            defaultTextProps={{
                                                                numberOfLines: 1
                                                            }}
                                                        />


                                                        {storeItemSubTypeInfo.subTypeDescription && 
                                                            <RenderHTML
                                                                contentWidth={width}
                                                                baseStyle={customWidgetSubTitleStyle}
                                                                source={{ html: storeItemSubTypeInfo.subTypeDescription}}
                                                                systemFonts={[customWidgetSubTitleStyle.fontFamily]}
                                                                id={`list_itemContainer_textContainer_subtitle hcommerce_storelevel1_itemContainer_textContainer_subtitle_${storeItemSubTypeInfo.id}`}
                                                                defaultTextProps={{
                                                                    numberOfLines: 1
                                                                }}
                                                            />
                                                        }
                                                    </View>

                                                    <View style={getStyles(['list_itemContainer_arrow', 'hcommerce_storelevel1_itemContainer_arrow'])} id={`list_itemContainer_arrow hcommerce_storelevel1_itemContainer_arrow_${storeItemSubTypeInfo.id}`}>
                                                        <ImageComp source={CHEVRON_RIGHT} />
                                                    </View>
                                                </CustomPressable>
                                            );
                                        }
                                        return null;
                                    })}
                                </View>}

                                {storeData.storeItemInfo?.length > 0 && <View style={getStyles(['hcommerce_storelevel1_ChildContainer_items_container'])} id="hcommerce_storelevel1_ChildContainer_items_container">
                                    {storeData.storeItemInfo.map((storeItemInfo, index) => {
                                        if (storeItemTypeInfo.storeItemID.includes(storeItemInfo.id)) {

                                            const totalQuantity = cartItem.reduce((total, item) => {
                                                return item.itemInfo.id === storeItemInfo.id ? total + item.quantity : total;
                                            }, 0);

                                            const imageUri = storeItemInfo.storeItemImages?.find(image => image.imageType === "LARGE")?.imagePath || storeItemInfo.storeItemImages?.[0]?.imagePath;
                                            return (
                                                <CustomPressable key={index} style={getStyles(['list_itemContainer', 'hcommerce_storelevel1_itemContainer'])} onPress={() => handleItemInfo(storeItemInfo)} id={`list_itemContainer hcommerce_storelevel1_itemContainer_${storeItemInfo.id}`}>

                                                    <View style={getStyles(['list_itemContainer_image', 'hcommerce_storelevel1_itemContainer_image'])} id="list_itemContainer_image hcommerce_storelevel1_itemContainer_image">
                                                        {imageUri &&
                                                            <ImageComp
                                                                source={getCleanUrl(imageUri)}
                                                                style={getStyles(["hcommerce_storelevel1_item_image", { width: "100%", height: "100%" }])}
                                                                id="hcommerce_storelevel1_item_image"
                                                            />
                                                        }
                                                    </View>
                                                    <View style={getStyles(['list_itemContainer_textContainer', 'hcommerce_storelevel1_itemContainer_textContainer'])} id="list_itemContainer_textContainer hcommerce_storelevel1_itemContainer_textContainer">
                                                        <RenderHTML
                                                            contentWidth={width}
                                                            baseStyle={customWidgetTitleStyle}
                                                            source={{ html: storeItemInfo.itemName}}
                                                            systemFonts={[customWidgetTitleStyle.fontFamily]}
                                                            id={`list_itemContainer_textContainer_subtitle hcommerce_storelevel1_itemContainer_textContainer_subtitle_${storeItemInfo.id}`}
                                                            defaultTextProps={{
                                                                numberOfLines: 1
                                                            }}
                                                        />

                                                        {storeItemInfo.itemDescription && 
                                                            <RenderHTML
                                                                contentWidth={width}
                                                                baseStyle={customWidgetSubTitleStyle}
                                                                source={{ html: storeItemInfo.itemDescription}}
                                                                systemFonts={[customWidgetSubTitleStyle.fontFamily]}
                                                                id={`list_itemContainer_textContainer_subtitle hcommerce_storelevel1_itemContainer_textContainer_subtitle_${storeItemInfo.id}`}
                                                                defaultTextProps={{
                                                                    numberOfLines: 1
                                                                }}
                                                            />
                                                        }



                                                        <View style={getStyles(['list_itemContainer_textContainer_tertiaryContainer', 'hcommerce_storelevel1_itemContainer_textContainer_tertiaryContainer'])} id="list_itemContainer_textContainer_tertiaryContainer hcommerce_storelevel1_itemContainer_textContainer_tertiaryContainer">

                                                            <Text style={getStyles(['list_itemContainer_textContainer_title', 'hcommerce_storelevel1_itemContainer_textContainer_currencytitle'])} id={`list_itemContainer_textContainer_title hcommerce_storelevel1_itemContainer_textContainer_currencytitle`}>{currencyCode + storeItemInfo.itemPrice}</Text>

                                                            <View style={getStyles(['additem_controls'])} id="additem_controls">
                                                                {totalQuantity > 0 &&
                                                                    <CustomPressable onPress={() => handleRemoveFromCart(storeItemInfo)} style={getStyles(['additem_controls_sub_container'])} id="additem_controls_sub_container">
                                                                        <ImageComp source={MINUS} style={getStyles(['additem_controls_sub_container_img'])} id="additem_controls_sub_container_img" />
                                                                    </CustomPressable>
                                                                }
                                                                {totalQuantity > 0 &&
                                                                    <Text style={getStyles(['additem_controls_qty_text'])} id="additem_controls_qty_text" >{totalQuantity}</Text>
                                                                }
                                                                <CustomPressable onPress={() => handleAddToCart(storeItemInfo)} style={getStyles(['additem_controls_sub_container'])} id="additem_controls_sub_container">
                                                                    <ImageComp source={PLUS} style={getStyles(['additem_controls_sub_container_img'])} id="additem_controls_sub_container_img" />
                                                                </CustomPressable>

                                                            </View>

                                                        </View>
                                                    </View>
                                                </CustomPressable>
                                            );
                                        }
                                        return null;
                                    })}
                                </View>}


                            </View>
                        );
                    }
                    return null;
                })}
            </ScrollView>
        </View>
    );
});

